import { computed } from 'vue';
import { useDialog } from '@negar/core';

import {
  CreateWatchlistDialog,
  WatchlistPriceDescriptionDialog,
} from '@/modules/watchlist';

import { i18n } from '@/plugins/i18n';

const { t } = i18n.global;

export default function useWatchlistDialogs() {
  const { add: addDialog } = useDialog();

  const openCreateWatchlistDialog = ({
    handleAfterCreateWatchlist,
  }: {
    handleAfterCreateWatchlist: () => Promise<void>;
  }) => {
    addDialog({
      title: t('modules.watchlist.create_title'),
      bodyClass: '!w-1/5',
      content: computed(() => ({
        component: CreateWatchlistDialog,
        props: {
          onAfterCreate: handleAfterCreateWatchlist,
        },
      })),
    });
  };

  const openWatchlistPriceDescriptionDialog = () => {
    addDialog({
      title: t('modules.watchlist.priceColumn'),
      bodyClass: '!w-[375px]',
      content: computed(() => ({
        component: WatchlistPriceDescriptionDialog,
        props: {},
      })),
    });
  };

  return {
    openCreateWatchlistDialog,
    openWatchlistPriceDescriptionDialog,
  };
}
